module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-15.aca292ed.jpg";